// extracted by mini-css-extract-plugin
export var headline6 = "bS_f9";
export var menuContainer = "bS_f6";
export var menuItem = "bS_f8";
export var menuList = "bS_f7";